export default "__VITE_ASSET__hsg15GwQ__"